exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".faq-container ul {\n  list-style: none;\n  padding-left: 0;\n}\n.faq-container .question {\n  padding: 20px 10px;\n}\n.faq-container .answer {\n  padding: 10px;\n  background: #F6F7FA;\n}\n.faq-container .font-weight {\n  font-weight: 800;\n}\n", ""]);

// exports
